import { render } from "./MyApply4Vendor.vue?vue&type=template&id=6ead99aa"
import script from "./MyApply4Vendor.vue?vue&type=script&lang=js"
export * from "./MyApply4Vendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__